module.exports = __webpack_public_path__ + "4de8f014/img/question-icon.06c20c5d.svg";